/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseObjectType from './BaseObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * The physical metadata object. <p>Java class for physicalObjectType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="physicalObjectType"&gt; &lt;complexContent&gt; &lt;extension base="{}baseObjectType"&gt; &lt;sequence&gt; &lt;element name="name" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="description" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="hidden" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="originalName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class PhysicalObjectType extends BaseObjectType{

	name = null;

	description = null;

	hidden = null;

	originalName = null;



	/**
	 * Gets the value of the name property.
	 * @return {String} possible object is {@link String}
	 */
	getName() {
		return this.name;
	}

	/**
	 * Sets the value of the name property.
	 * @param {String} value allowed object is {@link String}
	 */
	setName(value) {
		var oldValue = this.name;
		this.name = value;
		this._setAndNotify(5, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the description property.
	 * @return {String} possible object is {@link String}
	 */
	getDescription() {
		return this.description;
	}

	/**
	 * Sets the value of the description property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDescription(value) {
		var oldValue = this.description;
		this.description = value;
		this._setAndNotify(7, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the hidden property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isHidden() {
		return this.hidden;
	}

	/**
	 * Sets the value of the hidden property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setHidden(value) {
		var oldValue = this.hidden;
		this.hidden = value;
		this._setAndNotify(8, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the originalName property.
	 * @return {String} possible object is {@link String}
	 */
	getOriginalName() {
		return this.originalName;
	}

	/**
	 * Sets the value of the originalName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setOriginalName(value) {
		var oldValue = this.originalName;
		this.originalName = value;
		this._setAndNotify(6, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>PhysicalObjectType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> PhysicalObjectType</code> object from.
	 * @return {PhysicalObjectType} an object of type <code>PhysicalObjectType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createPhysicalObjectType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "PhysicalObjectType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 5, "name", null));
		featureList.push(this.createFeature(false, false, false, 7, "description", null));
		featureList.push(this.createFeature(false, false, false, 8, "hidden", null));
		featureList.push(this.createFeature(false, false, false, 6, "originalName", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 5:
			this.setName((value));
			break;
		case 6:
			this.setOriginalName((value));
			break;
		case 7:
			this.setDescription((value));
			break;
		case 8:
			this.setHidden((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 5:
			return this.getName();
		case 6:
			return this.getOriginalName();
		case 7:
			return this.getDescription();
		case 8:
			return this.isHidden();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 5:
			return this.getName();
		case 6:
			return this.getOriginalName();
		case 7:
			return this.getDescription();
		case 8:
			return this.isHidden();
		default:
			return super.basicGet(featureID);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/PhysicalObjectType.js